import { Component, Input } from '@angular/core';
import { DocumentsEnum } from '@app/core/enums/documents.enum';
import { PolicyProductIdEnum } from 'outshared-lib';

@Component({
    selector: 'ins-terms-and-conditions',
    templateUrl: 'terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent {
    @Input() userProductIdList: PolicyProductIdEnum[] = [];
    @Input() otherProductIdList: PolicyProductIdEnum[] = [];

    public documentsEnum = DocumentsEnum;
}
